import { EngineContext, SystemContext } from "@/App";
import { MObjectPrimitive } from "@/declare/interface/primitive";
import { useContext, useState } from "react";
import { Point } from "tnbase";
import "./mobject-label.less"
import { getMObjectPictureBase64 } from "@/utils/mobject-utils";
import classNames from "classnames";

interface IProps {
    mobject: MObjectPrimitive
}

const dangerHeight = 103
const normalHeight = 81

const dangerWidth = 47
const normalWidth = 37

export default function MObjectLabelItem(porps: IProps) {

    const { mobject } = porps

    // const [showDetail, setShowDetail] = useState<boolean>(false)

    /**
     * 引擎上下文，用于管理全局的引擎实例。
     */
    const engineContext = useContext(EngineContext);

    const systemContext = useContext(SystemContext)


    const isDanger = mobject.warning_level > 3

    const calPosition = (position: Point) => {
        const viewportStore = engineContext.engine.storage.viewportStore
        if (!viewportStore) return null
        let camera = viewportStore.viewportItems[viewportStore.currentViewportKey]?.camera
        if (!camera) return null
        let rect = viewportStore.getViewportRect(viewportStore.currentViewportKey)
        let vector = position.clone().project(camera)
        const width = rect.width
        const height = rect.height
        const screenX = (vector.x * 0.5 + 0.5) * width;
        const screenY = (- vector.y * 0.5 + 0.5) * height;

        return {
            x: screenX,
            y: screenY
        }
    }

    let pos = calPosition(mobject.primitive_center)

    const getWarningText = (wl: number) => {
        switch (wl) {
            case 0:
                return "非常安全";
            case 1:
                return "非常安全";
            case 2:
                return "安全";
            case 3:
                return "重点关注";
            case 4:
                return "预警";
            case 5:
                return "紧急";
            default:
                return "非常安全"
        }
    }

    return (
        <>
            <div
                className="mobject-label"
                style={{
                    left: pos.x - (isDanger ? dangerWidth / 2 : normalWidth / 2),
                    top: pos.y - (isDanger ? dangerHeight : normalHeight),
                    width: (isDanger ? dangerWidth : normalWidth),
                    height: (isDanger ? dangerHeight : normalHeight),
                }}
            >
                <img src={getMObjectPictureBase64(mobject.type, isDanger)} />
            </div>
            <div
                onClick={() => {
                    if (systemContext.showMObjectLabelDetailList.includes(mobject.id)) {
                        // 若是已经展开
                        if (systemContext.activeMonitorObjectId == mobject.id) {
                            // 取消展开
                            systemContext.setActiveMonitorObjectId(null)
                            systemContext.closeMObjectLabelDetail(mobject.id)
                        } else {
                            // 下方详情区显示数据
                            systemContext.setActiveMonitorObjectId(mobject.id)
                        }
                    } else {
                        // 若是未展开
                        systemContext.openMObjectLabelDetail(mobject.id)
                        systemContext.setActiveMonitorObjectId(mobject.id)
                    }
                }}
                className="mobject-label-click-area"
                style={{
                    left: pos.x - (isDanger ? dangerWidth / 2 : normalWidth / 2),
                    top: pos.y - (isDanger ? dangerHeight : normalHeight),
                    width: (isDanger ? dangerWidth : normalWidth),
                    height: (isDanger ? dangerWidth : normalWidth),
                }}
            >

            </div>
            {systemContext.showMObjectLabelDetailList.includes(mobject.id) && (
                <div
                    className={classNames({
                        "mobject-label-detail": true,
                        "mobject-label-detail-active": systemContext?.activeMonitorObjectId == mobject.id
                    })}
                    style={{
                        left: pos.x,
                        top: pos.y - (isDanger ? dangerHeight - dangerWidth : normalHeight - normalWidth),
                    }}
                >
                    <div className="detail-item">
                        <div className="item-label">
                            名称
                        </div>
                        <div className="item-value">
                            {mobject?.name}
                        </div>
                    </div>
                    <div className="detail-item">
                        <div className="item-label">
                            状态
                        </div>
                        <div className="item-value">
                            <div className={classNames({
                                "warning-level": true,
                                "warning-level-t1": [0, 1].includes(mobject.warning_level),
                                "warning-level-t2": mobject.warning_level == 2,
                                "warning-level-t3": mobject.warning_level == 3,
                                "warning-level-t4": mobject.warning_level == 4,
                                "warning-level-t5": mobject.warning_level == 5,
                            })}>
                                {getWarningText(mobject.warning_level)}
                            </div>
                        </div>
                    </div>

                </div>
            )}


        </>
    )

}